<div class="container">
  <div class="bar-container">
    <div *ngFor="let _ of filledCount()" class="bar-filled"></div>
    <div *ngFor="let _ of emptyCount()" class="bar-empty"></div>
  </div>
</div>
